/* HoneMD condensing header - adds .hm-header-condensed to <html> once the user
   scrolls past the top, removing it at the top. Padding/shadow transition is in
   CSS (and disabled under prefers-reduced-motion). rAF-throttled, passive. */
(function () {
  var THRESHOLD = 80;
  var root = document.documentElement;
  var ticking = false;

  function update() {
    var condensed = window.scrollY > THRESHOLD;
    root.classList.toggle('hm-header-condensed', condensed);
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });

  update();
})();
